import { createSlice } from "@reduxjs/toolkit";

export const initialData = {
  isOpenLoginModal: false,
  isOpenFilterModal: false,
  isOpenProductModal: false,
  isOpenGalleryModal: false,
  isOpenReportModal: false,
  reportFocus: null,
  isOpenInspectionModal: false,
  isOpenReferralModal: false,
  isOpenReservationModal: false,
  isOpenSavedCarsModal: false,
  isOpenProfileInfoModal: false,
  pendingAuthAction: null,
};

const dataSlice = createSlice({
  name: "modal",
  initialState: initialData,
  reducers: {
    openLoginModal: (state, action) => {
      state.isOpenLoginModal = true;
      state.pendingAuthAction = action.payload || null;
    },
    closeLoginModal: (state, action) => {
      state.isOpenLoginModal = false;
      state.pendingAuthAction = null;
    },
    openFilterModal: (state, action) => {
      state.isOpenFilterModal = true;
    },
    closeFilterModal: (state, action) => {
      state.isOpenFilterModal = false;
    },
    openProductModal: (state, action) => {
      state.isOpenProductModal = true;
    },
    closeProductModal: (state, action) => {
      state.isOpenProductModal = false;
    },
    openInspectionModal: (state, action) => {
      state.isOpenInspectionModal = true;
    },
    closeInspectionModal: (state, action) => {
      state.isOpenInspectionModal = false;
    },
    openGalleryModal: (state, action) => {
      state.isOpenGalleryModal = true;
    },
    closeGalleryModal: (state, action) => {
      state.isOpenGalleryModal = false;
    },
    openReportModal: (state, action) => {
      state.isOpenReportModal = true;
      state.reportFocus = action.payload || null;
    },
    closeReportModal: (state, action) => {
      state.isOpenReportModal = false;
      state.reportFocus = null;
    },
    openReferralModal: (state) => {
      state.isOpenReferralModal = true;
    },
    closeReferralModal: (state) => {
      state.isOpenReferralModal = false;
    },
    openReservationModal: (state) => {
      state.isOpenReservationModal = true;
    },
    closeReservationModal: (state) => {
      state.isOpenReservationModal = false;
    },
    openSavedCarsModal: (state) => {
      state.isOpenSavedCarsModal = true;
    },
    closeSavedCarsModal: (state) => {
      state.isOpenSavedCarsModal = false;
    },
    openProfileInfoModal: (state) => {
      state.isOpenProfileInfoModal = true;
    },
    closeProfileInfoModal: (state) => {
      state.isOpenProfileInfoModal = false;
    },
    // openBuyNowModal: (state, action) => {
    //   state.isOpenBuyNowModal = true;
    // },
    // closeBuyNowModal: (state, action) => {
    //   state.isOpenBuyNowModal = false;
    // },
    closeAllModal: (state, action) => {},
    setAnimationModal: (state, action) => {
      state.isAnimationModal = action.payload;
    },
    setShowModal: (state, action) => {
      state.showModal = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  openLoginModal,
  closeLoginModal,
  openFilterModal,
  closeFilterModal,
  openProductModal,
  closeProductModal,
  openInspectionModal,
  closeInspectionModal,
  openGalleryModal,
  closeGalleryModal,
  openReportModal,
  closeReportModal,
  openReferralModal,
  closeReferralModal,
  openReservationModal,
  closeReservationModal,
  openSavedCarsModal,
  closeSavedCarsModal,
  openProfileInfoModal,
  closeProfileInfoModal,
  closeAllModal,
  setAnimationModal,
  setShowModal,
} = dataSlice.actions;

export default dataSlice.reducer;
